import React from 'react';
import Slide from 'react-reveal/Slide';

// components
import Button from '../common/button';

import './style.scss';

const PageContent = (props) => {
	const { title, content, button } = props;
	return (
		<div className="page-content">
			<div className="page-content__title">
				<Slide bottom casecade>
					<h2 className="heading heading--super orange">{title}</h2>
				</Slide>
			</div>
			<div className="page-content__copy">
				<div className="wrapper">
					<Slide bottom casecade>
						<p>{content}</p>
					</Slide>
					{button.show && (
						<Slide bottom casecade>
							<Button type="link" action={button.link}>
								{button.text}
							</Button>
						</Slide>
					)}
				</div>
			</div>
		</div>
	);
};

export default PageContent;



// WEBPACK FOOTER //
// ./src/components/page-content/index.js